<template>
  <div class="login">
    <div class="container">
      <div class="logos">
        <img alt="logo kemnaker" src="@/assets/logo single.png" />
        <img alt="logo tka-hotline" src="@/assets/icon.png" />
      </div>
      <section>
        <h2>Login Akun TKA-Hotline</h2>
        <p class="welcome-text">Selamat datang di sistem TKA-Hotline</p>
        <label for="namabu">Username</label>
        <input type="text" v-model="username" name="username" id="username" placeholder="your username here"
          @keyup.enter="cekauth" />
        <label for="namabu">Password</label>
        <div class="password-wrapper">
          <input :type="showPassword ? 'text' : 'password'" v-model="password" name="password" id="password"
            placeholder="your password here" @keyup.enter="cekauth" />

          <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'" @click="showPassword = !showPassword"></i>
        </div>
        <button class="login-btn" @click="cekauth">login sekarang</button>
        <button class="login-sso-btn" @click="ceksso">
          <i v-if="!ssologin.active" class="fa-sharp fa-light fa-circle-user-circle-xmark"></i>
          <i v-if="ssologin.active" class="fa-sharp fa-light fa-circle-user-circle-check"></i>
          {{ ssologin.active ? ssologin.desTrue : ssologin.desFalse }}
        </button>

        <div class="error-info contain-info" v-if="errorinfo !== null">
          <div class="icon">
            <i class="fas fa-times"></i>
            <p class="error-code">
              <small> error code {{ errorinfo.code }} </small>
            </p>
          </div>

          <p class="info-message">
            {{ errorinfo.msg }}
          </p>
        </div>

        <div class="verify-info contain-info" v-if="verifyingstatus === false">
          <div class="icon">
            <i class="fas fa-spinner-scale"></i>
            <p class="error-code">
              <small> mohon tunggu sebentar </small>
            </p>
          </div>

          <p class="info-message">
            sedang melakukan verifikasi login SSO anda.
          </p>
        </div>
      </section>
    </div>

    <div class="informasi">
      <div class="wrap-info">
        <h1>Connecting With People...</h1>
      </div>

      <div class="card-info">
        <p>Note :</p>
        <p>
          Halaman login ini hanya untuk petugas TKA-Hotline, untuk perusahaan
          silahkan login lewat TKA-Online terlebih dahulu lalu kembali ke
          TKA-Hotline. Terima kasih.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { backend as be } from "@/assets/config/server.js";
import Swal from "sweetalert2";

import { useAccountStore } from "@/store/account";

import { bootstrapSession } from "@/services/bootstrap";
import { setCookie } from "@/assets/config/cookie";
import api from "@/services/api";
import { insertprofile } from "@/services/profile";

export default {
  name: "LoginDash",

  data() {
    return {
      username: "",
      password: "",
      showPassword: false,

      ssologin: {
        active: false,

        desTrue: "",

        desFalse: "login sso disini",
      },

      accountstore: null,

      loading: false,
      errorinfo: null,
      verifyingstatus: false,
      fileExcel: null,
    };
  },

  created() {
    this.accountstore = useAccountStore();
  },

  async mounted() {
    /*
    |--------------------------------------------------------------------------
    | Cek apakah sudah login SSO
    |--------------------------------------------------------------------------
    */
    // if (this.ceksession() == true) {
    //   await this.checkSSO();
    // }

    await this.checkSSO();
  },

  methods: {
    /*
    |--------------------------------------------------------------------------
    | LOGIN MANUAL PETUGAS HOTLINE
    |--------------------------------------------------------------------------
    */

    async ceksession() {
      try {
        const res = await api.post("/api/cek-session", {});

        console.log(res)

        if (res.data.status) {
          console.log("Session tersedia");
          return true;
        }
      } catch (err) {
        return false;
      }
    },

    async cekauth() {
      try {
        const res = await axios.post(`${be}/api/login`, {
          username: this.username,

          password: this.password,
        });

        const users = res.data;

        /*
        |--------------------------------------------------------------------------
        | Login perusahaan
        |--------------------------------------------------------------------------
        */

        // if (users.user.role_name === "Perusahaan") {
        //   this.accountstore.setUser({
        //     user: users.user,

        //     perusahaan: users.perusahaan,

        //     role: "Perusahaan",
        //   });

        //   if (users.perusahaan.status) {
        //     this.$router.replace("/user");
        //   } else {
        //     this.$router.replace("/user/dataisian");
        //   }

        //   return;
        // }

        /*
        |--------------------------------------------------------------------------
        | Login Agent
        |--------------------------------------------------------------------------
        */

        if (
          users.user.role_name === "Agent" ||
          users.user.role_name === "Supervisor"
        ) {
          const datalogin = JSON.stringify({
            ...users.user,
            token: users.token,
            isloggedin: true,
          });

          setCookie("loginInfo", datalogin);

          // this.accountstore.setUser({
          //   user: users.user,

          //   role: users.user.role_name,
          // });

          this.$router.replace("/agen");
        } else {
          this.errorinfo.code = 401;
          this.errorinfo.msg = "Perusahaan tidak bisa login lewat sini.";
        }
      } catch (err) {
        Swal.fire({
          title: "Gagal Login!",

          text: "Username atau password salah",

          icon: "error",

          confirmButtonText: "OK",
        });

        console.error(err);
      }
    },

    /*
    |--------------------------------------------------------------------------
    | LOGIN SSO
    |--------------------------------------------------------------------------
    */

    async checkSSO() {
      if (this.ceksession() == false) {
        this.errorinfo.msg =
          "Anda belum login di TKA-Online. Mohon login di TKA-Online terlebih dahulu.";
        return
      }

      this.loading = true;

      try {
        const bootstrapsession = await bootstrapSession();

        this.errorinfo = {};

        if (bootstrapsession.status !== 200) {
          const status = bootstrapsession.status;

          this.verifyingstatus = true;
          this.errorinfo.code = status;

          if (status === 401) {
            this.errorinfo.msg =
              "Anda belum login di TKA-Online. Mohon login di TKA-Online terlebih dahulu.";
          } else if (status === 404) {
            // USER SSO ADA
            // TAPI DATA USER TIDAK ADA DI TKA-HOTLINE
            await insertprofile()
            //console.log("cek isi jwt di insertprofile :",req)

            this.$router.replace("/user/dataisian");

            return;
          } else if (status === 500) {
            this.errorinfo.msg =
              "Gagal verifikasi login, mohon muat ulang (refresh) halaman ini.";
          } else {
            this.errorinfo.msg =
              "Sesi login telah berakhir, silahkan login di TKA-Online kembali.";
          }

          return;
        }

        /*
         * Kalau profile berhasil
         */
        // console.log(
        //   this.accountstore.perusahaan.status,
        //   this.accountstore.role,
        //   this.accountstore.isLoggedIn,
        // );

        this.ssologin.active = true;

        this.ssologin.desTrue = `Silahkan masuk sebagai ${this.accountstore.user}`;

        /*
         * Redirect otomatis perusahaan
         */
        if (this.accountstore.role === "Perusahaan") {
          if (this.accountstore.perusahaan.status) {
            this.$router.replace("/user");
          } else {
            this.$router.replace("/user/dataisian");
          }
        }
      } catch (err) {
        console.log("Tidak ada session SSO", err);
      } finally {
        this.loading = false;
      }
    },

    ceksso() {
      if (this.ssologin.active) {
        this.$router.replace("/user");
      } else {
        window.location = "https://tka-online.kemnaker.go.id/apl/account/login";
      }
    },
  },
};
</script>

<style>
.logos {
  margin-left: auto;
  margin-right: auto;
  width: max-content;
  display: grid;
  grid-gap: 30px;
  grid-template-columns: repeat(2, max-content);
}

img {
  width: max-content;
  height: 70px;
  object-fit: contain;
}

.login {
  width: 100%;
  height: 100vh;
  background-color: transparent;
  display: grid;
  grid-template-columns: 40% 60%;

  .informasi {
    width: 100%;
    background-color: #0c4dc5;
    display: flex;
    align-items: center;
    justify-content: center;

    .card-info {
      height: max-content;
      width: max-content;
      max-width: 400px;
      border-radius: 5px;
      padding: 20px;
      background-color: #5490ff97;
      position: absolute;
      color: white;
      transform: translateY(200px);
      box-shadow: 0px 15px 20px #2121211b;
    }

    .wrap-info {
      width: max-content;
      display: inline-block;
      height: max-content;

      h1 {
        font-family: poppins-bold;
        font-size: 40pt;
        color: white;
      }
    }
  }

  .container {
    display: block;
    background-color: transparent;
    width: 350px;
    margin-left: auto;
    margin-right: auto;

    input {
      border: 2px solid #f2f2f2;
      padding: 7px 10px;
      box-sizing: border-box;
      font-family: poppins-reg;
      border-radius: 5px;
      font-size: 9pt;
      width: 100%;
      margin-top: 5px;
    }

    .welcome-text {
      text-align: center;
    }

    .contain-info {
      margin-top: 20px;
      box-sizing: border-box;
      width: 100%;
      height: max-content;
      border-radius: 10px;
      padding: 10px;

      .icon {
        font-size: 11pt;
        width: max-content;
        padding: 5px 10px;
        border-radius: 15px;
        display: flex;
        box-sizing: border-box;
        align-items: center;

        .error-code {
          display: flex;
          align-items: center;
        }
      }

      .info-message {
        margin-top: 10px;
        font-size: 10pt;
      }
    }

    .error-info {
      background-color: #ff808034;

      .icon {
        background-color: #fc79795f;
        color: red;
      }

      .info-message {
        color: red;
      }
    }

    .verify-info {
      background-color: #8091ff34;

      .icon {
        background-color: #799cfc5f;
        color: #0066ff;
      }

      .info-message {
        color: #0066ff;
      }
    }

    label {
      display: block;
      font-family: poppins-semi;
      font-size: 10pt;
      margin-top: 10px;
    }

    h2 {
      text-align: center;
      margin-bottom: 10px;
    }

    img {
      margin-top: 100px;
      margin-bottom: 20px;
      margin-left: 50%;
      transform: translateX(-50%);
    }

    button {
      display: block;
      width: 100%;
      margin-top: 10px;
      border: none;
      padding: 15px 12px;
      font-family: poppins-reg;
      font-size: 9pt;
      border-radius: 5px;
      box-sizing: border-box;
      cursor: pointer;
    }

    .login-btn {
      margin-top: 20px;
      color: white;
      background-color: #1869ff;
    }

    .login-sso-btn {
      display: flex;
      justify-content: start;
      align-items: center;

      i {
        font-size: 15pt;
        margin-left: 10px;
        margin-right: 15px;
      }
    }
  }
}

.password-wrapper {
  position: relative;
}

.password-wrapper input {
  width: 100%;
  padding-right: 40px;
}

.password-wrapper i {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #888;
  font-size: 14px;
}

.password-wrapper i:hover {
  color: #1869ff;
}
</style>
